import { ENV } from "../utils";

export class AuditLog {
  baseApi = ENV.BASE_API;

  /**
   * Obtener registros de auditoría con filtros (paginado)
   * @param {string} accessToken
   * @param {Object} filters - { documentId, documentType, site, changedBy, year, startDate, endDate, page, limit }
   */
  async getAuditLogs(accessToken, filters = {}) {
    try {
      const queryParams = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, value);
        }
      });

      const url = `${this.baseApi}/audit-logs?${queryParams.toString()}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtener historial de cambios de un documento específico
   * @param {string} accessToken
   * @param {string} documentType - energy, water, waste, fuel, effluent, air, production, social, dangerous
   * @param {string} documentId
   */
  async getAuditLogsByDocument(accessToken, documentType, documentId) {
    try {
      const url = `${this.baseApi}/audit-logs/document/${documentType}/${documentId}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtener historial de cambios de un campo específico
   * @param {string} accessToken
   * @param {string} documentId
   * @param {string} field - nombre del campo
   */
  async getAuditLogsByField(accessToken, documentId, field) {
    try {
      const url = `${this.baseApi}/audit-logs/field/${documentId}/${field}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtener resumen de cambios por sitio
   * @param {string} accessToken
   * @param {string} siteId
   * @param {string} year - opcional
   */
  async getAuditSummaryBySite(accessToken, siteId, year = null) {
    try {
      let url = `${this.baseApi}/audit-logs/summary/${siteId}`;
      if (year) {
        url += `?year=${year}`;
      }

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Actualizar campo con registro de auditoría
   * @param {string} accessToken
   * @param {string} documentType - energy, water, waste, fuel, effluent, air, production, social, dangerous
   * @param {string} documentId
   * @param {string} field - nombre del campo a actualizar
   * @param {Object} data - { newValue, newUnit, reason }
   */
  async updateFieldWithAudit(accessToken, documentType, documentId, field, data) {
    try {
      const url = `${this.baseApi}/audit-log/update/${documentType}/${documentId}/${field}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Crear registro de auditoría manualmente (uso interno)
   * @param {string} accessToken
   * @param {Object} auditData
   */
  async createAuditLog(accessToken, auditData) {
    try {
      const url = `${this.baseApi}/audit-log`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(auditData),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
